export const getOSName = () => {
  const userAgent = window.navigator.userAgent
  const platform = window.navigator.platform
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  const iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let osName = null

  if (macosPlatforms.indexOf(platform) !== -1) {
    osName = 'Mac OS'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    osName = 'iOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    osName = 'Windows'
  } else if (/Android/.test(userAgent)) {
    osName = 'Android'
  } else if (/Linux/.test(platform)) {
    osName = 'Linux'
  }

  return osName
}

export const getOSDetailName = () => {
  const userAgent = window.navigator.userAgent

  return userAgent
}



// WEBPACK FOOTER //
// ./src/utils/common.js